import DOMPurify from 'dompurify';
import parse, {Element, HTMLReactParserOptions, DOMNode, domToReact} from 'html-react-parser';

import {ActionStyle, ActionType, BodyText, BodyTypes} from 'components/design-guide';
import Action from 'components/design-guide/Action';

const sanitize = (html: string) =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['#text', 'b', 'i', 'u', 'br', 'p', 'li', 'ul', 'a'],
    KEEP_CONTENT: false
  });

//https://github.com/remarkablemark/html-react-parser/issues/221
const isElement = (domNode: DOMNode): domNode is Element => {
  const isTag = domNode.type === 'tag';
  const hasAttributes = (domNode as Element).attribs !== undefined;

  return isTag && hasAttributes;
};

const isWhitelistedURL =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([a-z0-9.]*\.)?((amica\.com)|(gov))(\/.*)?$/;
const isWhitelistedEmail = /^(mailto:)[a-z0-9]+(@amica\.com)$/;
const isValidTelephone = /^(tel:(\+?1-?)?[0-9]{3}-?[0-9]{3}-?[0-9]{4})$/;
const validateHref = (href: string) =>
  isWhitelistedURL.test(href) || isWhitelistedEmail.test(href) || isValidTelephone.test(href);

const parseOptions: HTMLReactParserOptions = {
  replace: (domNode: DOMNode) => {
    if (!isElement(domNode)) {
      return domNode;
    }
    switch (domNode.name) {
      case 'a':
        return validateHref(domNode.attribs.href) ? (
          <Action
            name={'adobe-target-message-link'}
            actionStyle={ActionStyle.INLINE_TEXT}
            actionType={ActionType.ROUTER}
            typeProps={{to: domNode.attribs.href}}>
            {domToReact(domNode.children as DOMNode[])}
          </Action>
        ) : (
          <></>
        );
      case 'p':
        return <BodyText type={BodyTypes.BODYSPAN}>{domToReact(domNode.children as DOMNode[])}</BodyText>;
      default:
        return domNode;
    }
  }
};

export const SafelyParseHTML = ({htmlString}: {htmlString: string}) => {
  const purifiedHtml = sanitize(htmlString);
  return <>{parse(purifiedHtml, parseOptions)}</>;
};
